import { createElement } from 'react'

import { FormItemType } from '../../constants/form-builder.constants'
import { FormBuilderConfig } from '../../types/form-builder.types'
import { builderComponentFactory } from '../../utils/builder-component-factory'

type FormBuilderFormFactoryItemType = {
  type: FormItemType
  props: FormBuilderConfig
  formikProps: any
  isDisabled: boolean
  error: string[]
}

export const FormBuilderFormFactoryItem = ({ type, props, formikProps, error, isDisabled = false }: FormBuilderFormFactoryItemType) => {
  return createElement(builderComponentFactory(type), {
    ...formikProps,
    ...props,
    placeholder: isDisabled ? '' : props.placeholder,
    disabled: isDisabled,
    error: error,
    size: 'small',
    // isBuilder: true,
  })
}
